import usePermissions from '../hooks/usePermissions';
import { Navigate } from 'react-router-dom';
import type { ReactElement, ReactNode } from 'react';

interface ProtectedRouteProps {
	excludedUsers?: number[];
	redirectPath?: string;
	children: ReactNode;
}

export default function RestrictedRoute({
	children,
	excludedUsers,
	redirectPath = '/'
}: Readonly<ProtectedRouteProps>): ReactElement {
	const { userAccountTypeID } = usePermissions();
	if (excludedUsers && excludedUsers.includes(userAccountTypeID)) {
		return <Navigate to={redirectPath} replace />;
	}
	return <>{children}</>;
}
